export const etatPanierItemListProps = () => ({
  produits: {
    type: Array,
    required: false,
    default: () => { return [] }
  },
  showSimilaires: {
    type: Boolean,
    required: false,
    default: false
  },
  showQuantiteInsuffisante: {
    type: Boolean,
    required: false,
    default: false
  }
})